import { render, staticRenderFns } from "./club-info-card.vue?vue&type=template&id=588d8032"
import script from "./club-info-card.vue?vue&type=script&lang=js"
export * from "./club-info-card.vue?vue&type=script&lang=js"
import style0 from "./club-info-card.vue?vue&type=style&index=0&id=588d8032&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/projects/subsapp-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('588d8032')) {
      api.createRecord('588d8032', component.options)
    } else {
      api.reload('588d8032', component.options)
    }
    module.hot.accept("./club-info-card.vue?vue&type=template&id=588d8032", function () {
      api.rerender('588d8032', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/admin/club-info/club-info-card.vue"
export default component.exports